import React, { useState } from "react";
import DashboardLayout from "../../DashboardLayout";
import { Button, Form, Table } from "react-bootstrap";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

function ClickThroughRate() {
  // Static data
  const tableData = [
    { game: "Mario", ctr: 5.0, userType: "Registered" },
    { game: "Sonic", ctr: 2.0, userType: "Guest" },
    { game: "Pac-Man", ctr: 3.0, userType: "Registered" },
    { game: "Donkey Kong", ctr: 1.0, userType: "Guest" },
    { game: "Street Fighter", ctr: 4.0, userType: "Registered" },
  ];

  const [userType, setUserType] = useState("");

  const handleFilterChange = (e) => {
    setUserType(e.target.value);
  };

  const handleReset = () => {
    setUserType("");
  };

  const filteredData = tableData.filter((item) =>
    userType ? item.userType === userType : true
  );

  // Prepare chart data
  const games = [...new Set(filteredData.map((d) => d.game))];
  const guestCtrs = games.map((game) => {
    const found = filteredData.find(
      (d) => d.game === game && d.userType === "Guest"
    );
    return found ? found.ctr : 0;
  });
  const registeredCtrs = games.map((game) => {
    const found = filteredData.find(
      (d) => d.game === game && d.userType === "Registered"
    );
    return found ? found.ctr : 0;
  });

  const chartData = {
    labels: games,
    datasets: [
      {
        label: "Guest CTR (%)",
        data: guestCtrs,
        backgroundColor: "rgba(255, 99, 132, 0.6)",
      },
      {
        label: "Registered CTR (%)",
        data: registeredCtrs,
        backgroundColor: "rgba(54, 162, 235, 0.6)",
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    plugins: {
      legend: {
        labels: { color: "#fff" },
      },
    },
    scales: {
      x: { ticks: { color: "#fff" } },
      y: {
        beginAtZero: true,
        ticks: { color: "#fff", callback: (v) => `${v}%` },
      },
    },
  };

  return (
    <DashboardLayout>
      {/* Top Card: Filter */}
      <div className="card bg-dark text-white mt-3">
        <div className="card-body">
          <h5 className="card-title">Filter by User Type</h5>
          <div className="row align-items-center mb-3">
            <div className="col-md-3">
              <Form.Select
                className="bg-dark text-light border-light"
                value={userType}
                onChange={handleFilterChange}
              >
                <option value="">All user types</option>
                <option value="Guest">Guest</option>
                <option value="Registered">Registered</option>
              </Form.Select>
            </div>
            <div className="col-md-2">
              <Button variant="success" onClick={handleReset}>
                Reset
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* Table Card */}
      <div className="card bg-dark text-white mt-3">
        <div className="card-body">
          <h5 className="card-title">Click-Through Rate (CTR)</h5>
              <p className="card-text">
                Analyzing this data can help you identify Percentage of users who click on ads after viewing.
              </p>
          <div className="table-responsive">
            <Table className="table-hover table-striped align-middle table-borderless table-dark mb-0">
              <thead>
                <tr>
                  <th>Game Name</th>
                  <th>CTR (%)</th>
                  <th>User Type</th>
                </tr>
              </thead>
              <tbody>
                {filteredData.map((item, idx) => (
                  <tr key={idx}>
                    <td>{item.game}</td>
                    <td>{item.ctr.toFixed(2)}%</td>
                    <td>{item.userType}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
            {filteredData.length === 0 && (
              <p className="text-muted mt-3">No data available.</p>
            )}
          </div>
        </div>
      </div>

      {/* Chart Card */}
      <div className="card bg-dark text-white mt-3">
        <div className="card-body">
          <h6 className="mb-3">CTR by Game and User Type</h6>
          <Bar data={chartData} options={chartOptions} />
        </div>
      </div>
    </DashboardLayout>
  );
}

export default ClickThroughRate;